import type { NewsletterStatus } from "@sdk/core";

export function parseNewsletterSearch(search: Record<string, unknown>) {
  const text = (key: string) =>
    typeof search[key] === "string"
      ? (search[key] as string).trim().slice(0, 256)
      : "";
  const integer = (key: string, fallback: number, max: number) =>
    Number.isInteger(Number(search[key])) && Number(search[key]) > 0
      ? Math.min(Number(search[key]), max)
      : fallback;
  return {
    q: text("q"),
    status: (["pending", "subscribed", "unsubscribed", "bounced"].includes(
      text("status"),
    )
      ? text("status")
      : "") as NewsletterStatus | "",
    consent: (["eligible", "missing"].includes(text("consent"))
      ? text("consent")
      : "") as "eligible" | "missing" | "",
    page: integer("page", 1, 1_000_000),
    pageSize: integer("pageSize", 25, 100),
    importId: /^[a-f0-9-]{36}$/i.test(text("importId")) ? text("importId") : "",
  };
}
export type NewsletterSearch = ReturnType<typeof parseNewsletterSearch>;
